// build-fingerprint: bWFsY29iYXNpbGlvQGdtYWlsLmNvbQ==
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { LegalBanner } from "@/components/layout/LegalBanner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import WizardPage from "@/pages/WizardPage";
import DashboardPage from "@/pages/DashboardPage";
import SuccessPage from "@/pages/SuccessPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PackagePage from "@/pages/PackagePage";
import FormAdvisorPage from "@/pages/FormAdvisorPage";
import PricingPage from "@/pages/PricingPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="App flex min-h-screen flex-col">
            <LegalBanner />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/advisor" element={<FormAdvisorPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                  path="/wizard"
                  element={
                    <ProtectedRoute>
                      <WizardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/wizard/:formId"
                  element={
                    <ProtectedRoute>
                      <WizardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/success/:formId"
                  element={
                    <ProtectedRoute>
                      <SuccessPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/packages"
                  element={
                    <ProtectedRoute>
                      <PackagePage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" richColors />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
